export const state = {
	clientsettings: [],
	usersettings: [],
	vpsList: [],
	subscriptionList: [],
	subscriptionDetail: [],
	userOtherDetail: {},
	transactionList: [],
	cardList: [],
	getClientData: {},

	countriesList: {},
	citiesList: [],
	emailData: [],

	groupAdminName: {},
	userGroupId: {},

	// Coupon
	couponList: [],
	sunPlanList: [],
	subExistList: [],
	subPlanDetail: [],

	// Reporting
	reportingList: [],
	emirList: [],

	// Email
	emailList: [],

	// Admin
	adminList: [],
	adminDetail: [],

	notificationList: [],
	notificationDetail: [],
	notificationListOld: [],
	notificationListUnread: [],
	uploadsList: [],
	clientLeads: [],

	// IB
	iblist: [],
	ibView: [],
	ibchangelist: [],

	// Client
	catList: [],
	articleList: [],
	userList: [],
	userView: [],
	logsList: [],
	logsView: [],
	userCount: [],

	commissionReportList: {},
	commissionWithdrawalList: {},
	commissionReportDetail: {},
	thrdPartyList: [
		{
			key: "01",
			value:
				"No such risk. The Company at all times requests for Power of Attorney stating the Authorised Representative(s) of the Account",
		},
	],
	fundSrcList: {
		"01": "Client",
		"02": "Third Party",
		"03": "Anonymous",
	},
	idenVerList: [
		{ key: "01", value: "Face to Face Identification and Verification" },
		{
			key: "02",
			value:
				"Non Face to Face Identification and Verification = Original or Certified True Copies of KYC",
		},
		{
			key: "03",
			value:
				"Non Face to Face Identification and Verification - Compliance with Section 2 of Fourth Appendix of Directive = Plain Copies of Originals",
		},
		{
			key: "04",
			value:
				"Non Face to Face Identification and Verification - NOT in compliance with Section 2 of Fourth Appendix of Directive = Plain Copies of Originals",
		},
		{
			key: "05",
			value: "No KYC provided/Failed to Verify Client/Client Unwilling to Provide",
		},
	],
	genderList: { M: "male", F: "female" },
	chnlRiskList: {
		"01": "Employee/Senior Management Recommendation/Meeting",
		"02": "Introduction from existing client whose AML Risk is Low/Medium",
		"03": "Introduction via Tied Agent, Affiliate, Introducer, Agent",
		"04": "Online, no communication, own initiative",
	},
	deptMethdList: {
		"01": "Credit Institution (Wire Transfer)",
		"02": "Credit/Debit Card",
		"03": "Financial Institution/Payment Institution",
		"04": "E-Wallet/Electronic Money",
		"05": "Cash",
	},
	credInsList: [
		{ key: "01", value: "EU/EEA Credit Institution (Regulated)" },
		{
			key: "02",
			value: "EU/EEA Financial Institution/Payment Institution (Regulated)",
		},
		{ key: "03", value: "EU/EEA E-Wallet (Regulated)" },
		{
			key: "04",
			value:
				"EU/FATF - High Risk Country/Sanction List/Corruption List/Panama papers = Credit Institution/Financial Institution/Payment Institution/E-Wallet (Regulated & Unregulated)",
		},
		{
			key: "05",
			value:
				"Other 3rd Country Credit/Financial Institution/Payment Institution/E-Wallet (Unregulated)",
		},
		{
			key: "06",
			value:
				"Other 3rd Country Credit/Financial Institution/Payment Institution/E-Wallet (Regulated)",
		},
	],

	stepList: {
		"0": "Initiated",
		"1": "On Personal",
		"2": "Declaration",
		"3": "Documents Uploaded",
	},
	timeZone: {
		"Asia/Kolkata": "India",
		"Europe/Nicosia": "Cyprus",
		"Europe/London": "UK",
	},

	internalNotes: [],
	riskMetrix: [],

	// Ticket
	ticketList: [],
	ticketView: [],
	ticketDocs: [],
	ticketData: [],
	ticketStatus: {
		"0": "open",
		"1": "doc verified",
		"2": "cancel",
		"3": "close",
	},
	ticketReason: {
		"1": "Document Upload",
		"2": "Email Change",
		"3": "Mobile Number Change",
	},
	ticketReasonList: [],
	ticketReasonList1: [],
	department_list: [
		{ id: "3", description: "Reporting Manager", role: "RM" },
		{ id: "4", description: "Back Office - Admin", role: "BO-A" },
		{ id: "5", description: "Back Office - Manager", role: "BO-M" },
		{ id: "6", description: "Back Office", role: "BO" },
		{ id: "7", description: "Accounts - Admin", role: "AC-A" },
		{ id: "8", description: "Accounts - Manager", role: "AC-M" },
		{ id: "9", description: "Accounts", role: "AC" },
		{ id: "10", description: "IT", role: "IT" },
		{ id: "11", description: "Customer Support", role: "CS" },
		{ id: "18", description: "Reporting Manager - Admin", role: "RM-A" },
		{ id: "19", description: "Reporting Manager - Manager", role: "RM-M" },
		{ id: "20", description: "RMS", role: "RMS" },
		{ id: "21", description: "RMS - Admin", role: "RMS-A" },
		{ id: "22", description: "RMS - Manager", role: "RMS-M" },
		{
			id: "23",
			description: "RM's who have authority to reply tickets",
			role: "RM-R",
		},
		{ id: "24", description: "Compliance role", role: "CM-A" },
	],
	ticket_reply_pre: [
		{ name: "A", message: "please wait for reply" },
		{ name: "B", message: "ticket Reject" },
		{ name: "C", message: "please wait for rejection" },
		{ name: "D", message: "ticket approve" },
	],

	// Deposit
	depositList: [],
	depositView: [],
	depositTransactionList: [],
	depositStatus: {
		"-1": "Transaction Initiated",
		"0": "pending",
		"1": "success",
		"2": "Declined",
		"3": "Declined",
		"4": "unverified account",
	},
	depositMethod: {
		"1": '"Autopay"', "2": '"Bitstamp"', "3": '"CR"', "4": '"Ecommpay"', "5": '" Eurobank"', "6": '" Inactivity fees"', "7": '"NBP"', '8': '" Neteller"', '9': '"Refund"', '10': '"Skrill"', '11': '"TR"', '12': '"Trading account"'
	},
	depositMethods: [],

	// Bonus
	bonusList: [],
	bonusView: [],

	// Withdrawal
	withdrawalList: [],
	withdrawalListMaker: [],
	withdrawalView: [],
	withdrawalType: {
		"1": "Withdrawal",
		"2": "Internal Transfer",
		"3": "Subscription",
	},
	withdrawalMethods: {
		"1": "bank_transfer.png",
		"2": "skrill.png",
		"3": "neteller.png",
		"5": "CreditCard.svg",
		"6": "Giropay.svg",
		"7": "przelewy-24.svg",
		"8": "rapid-transfer.svg",
		"9": "Nordea.svg",
		"10": "Klarna.svg",
	},
	withdrawalMethod: {
		"1": '"Autopay"', "2": '"Bitstamp"', "3": '"CR"', "4": '"Ecommpay"', "5": '" Eurobank"', "6": '" Inactivity fees"', "7": '"NBP"', '8': '" Neteller"', '9': '"Refund"', '10': '"Skrill"', '11': '"TR"', '12': '"Trading account"'
	},
	withdrawalMethodResponse: [],
	withdrawalStatus: {
		"0": "pending",
		"1": "processed",
		"2": "rejected",
		"3": "rejected",
	},

	// Trading
	tradingList: [],
	tradingView: [],
	demoLive: { "0": "demo", "1": "live" },
	currency: {
		EUR: "eur.svg",
		USD: "usd.svg",
		GBP: "gbp.svg",
		CHF: "chf.svg",
		JPY: "jpy.svg",
		AUD: "aud.svg",
	},

	// Bonus
	bonusType: { "1": "Add Bonus", "2": "Remove Bonus" },
	bonusStatus: { "0": "open", "1": "processed" },

	// Permission
	permission: [],

	// Tutorials
	tutorialList: [],
	tutorialCourse: [],
	tutorialCat: [],

	// Trading Education
	categoryList: [],
	postList: [],

	ticketDocsLink:
		"https://global.fxview.com:2083/get/docs?type=",
	downloadUserZip:
		"https://global-admin.fxview.com:2083/get/zip?id=",

	withdrawalDocsLink:
		"https://global-admin.fxview.com:2083/get/docs?type=",
	clientReportLink:
		"https://global.fxview.com:2083/get/docs?type=clientReport&id=1&doc=",
	reportDocLink:
		"https://global-admin.fxview.com:2083/get/report/zip?from=",

	IbUserDocsLink:
		"https://partners.fxview.com:2096/get/docs?type=user&id=",
	IbticketDocsLink:
		"https://partners.fxview.com:2096/get/docs?type=ticket&id=",
};


// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/state.js